import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { fetchAuthSession } from 'aws-amplify/auth';
import { environment } from '../../environment/environment';

@Injectable({
  providedIn: 'root',
})
export class GlobalAdminGuard implements CanActivate {
  constructor(private router: Router) {}

  async canActivate(): Promise<boolean> {
    try {
      const session = await fetchAuthSession();
      const idToken = session.tokens?.idToken;

      if (idToken) {
        const payload = JSON.parse(atob(idToken.toString().split('.')[1]));
        const userGroups: string[] = payload['cognito:groups'] || [];
        const isGlobalAdmin = userGroups.some((group: string) =>
          group.includes('global-admin'),
        );
        if (isGlobalAdmin) {
          return true;
        }
      }

      this.router.navigate(['/app']);
      return false;
    } catch (error) {
      console.error('Error checking global admin permissions:', error);
      this.router.navigate(['/app']);
      return false;
    }
  }
}
